<template>
	<!-- Retain focus = false, to prevent stack size error -->
	<v-dialog v-model="vmodel" max-width="800" :retain-focus="false" persistent no-click-animation>
		<v-card>
			<v-card-title class="primary white--text pb-4" style="font-family: Lexia !important; font-size: 22px;">
				{{ label }}
				<v-spacer></v-spacer>
				<v-text-field v-model="search" placeholder="Search" prepend-inner-icon="mdi-magnify" hide-details
					clearable flat solo>
				</v-text-field>
			</v-card-title>

			<v-card-text>
				<v-data-table v-model="selected" :headers="headers" :items="items" :dense="items.length > 10"
					:items-per-page="-1" :search="search" class="selectorTable elevation-0" show-select
					:single-select="!multiple" item-key="value"
					style="margin-top: 20px; max-height: 60vh; overflow-y: auto;" hide-default-footer>
					<template v-slot:header.data-table-select>
						<v-simple-checkbox v-if="multiple" :value="!hasNoneSelected" @click="toggleAll"
							:indeterminate="!hasAllSelected && !hasNoneSelected" color="primary"></v-simple-checkbox>
					</template>
					<template v-slot:item="{ item, index, isSelected, select }">
						<tr @click.stop="select(!isSelected)" style="cursor: pointer;">
							<td>
								<v-simple-checkbox :value="isSelected" @click.stop="select(!isSelected)"
									color="primary">
								</v-simple-checkbox>
							</td>
							<td v-for="header in headers" :key="header.name + index">
								<span v-if="!item[header.value]" style="font-style: italic;">None Specified (placed at: 0 N, 0 E)</span>
								<span v-else-if="item[header.value]==='multiple'" style="font-style: italic;">Multiple Regions (placed at: 0 N, 0 E)</span>
								<span v-else>{{item[header.value]}}</span>
							</td>
						</tr>
					</template>
				</v-data-table>
				<v-divider></v-divider>
			</v-card-text>

			<slot name="message"></slot>

			<v-card-actions class="mx-2 pb-4 pt-2">
				<v-spacer></v-spacer>
				<v-btn text class="pt-1" @click="close">
					close
				</v-btn>
				<v-btn :disabled="!valid" color="primary" class="pt-1" @click="update">
					Update
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { Items } from '../../../ts/filters'

	export default {
		props: {
			value: {
				type: Boolean,
			},
			filter: {
				required: false,
				type: Items,
				default: () => []
			},
			sortItemsCaseInsensitive: {
				required: false,
				type: Boolean,
				default: false
			},
			label: {
				required: false,
				type: String,
				default: ""
			},
			multiple: { // TODO: this should probably live in filter logic!
				required: false,
				type: Boolean,
				default: true
			},
		},
		watch: {
			value() {
				this.$emit('input', this.value)
			},
			// Update filters on dialog open
			vmodel(visible) {
				if (visible) {
					this.init()
				}
			}
		}, 
		computed: {
			vmodel: {
				get() {
					return this.value
				},
				set(localValue) {
					this.$emit('input', localValue)
				}
			},
			items() {
				if (this.sortItemsCaseInsensitive) {
					// Sort alphabetically (case insensitive)
					return this.filter.getAll().sort((a,b) =>
						(a.value.toLowerCase() > b.value.toLowerCase()) ? 1 : ((b.value.toLowerCase() > a.value.toLowerCase()) ? -1 : 0));
				}
				else {
					return this.filter.getAll().sort((a, b) => {
						// Move 'Multiple Regions (placed at: 0 N, 0 E)' to the end
						if (a.value === 'multiple') return 1;
						if (b.value === 'multiple') return -1;
						
						// push items with numbers or empty values to the end
						const aHasNumber = /\d/.test(a.value);
						const bHasNumber = /\d/.test(b.value);
						if ((aHasNumber || !a.value) && !bHasNumber) return 1;
						if (!aHasNumber && (bHasNumber || !b.value)) return -1;
						
						return 0;
					})
				}
			},
			hasNoneSelected() {
				return this.selected.length === 0
			},
			hasAllSelected() {
				return this.selected.length === this.filter.getAll().length
			},
			valid() {
				return !this.hasNoneSelected
			}
		},
		data() {
			return {
				headers: [
					{ text: this.multiple ? "Select All / Deselect All" : "", value: "text", sortable: false }
				],

				// Below are variables that should not retain data between form open/ closes.
				selected: this.filter.getSelected(),
				search: "",
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.selected = this.filter.getSelected()
				this.search = ""
			},
			close() {
				this.vmodel = false
				this.init()
			},
			update() {
				this.vmodel = false
				this.$nextTick(() => {
					this.filter.select(this.selected.map(o => o.value))
				})
			},
			toggleAll() {
				this.selected = this.hasNoneSelected ? this.filter.getAll() : []
			},
		}
	}

</script>

<style>
	.selectorTable .v-data-footer__select {
		display: none !important;
	}
</style>